<template>
  <div class="breadcrumbs">
    <div v-if="displayBreadcrumbs.length > 0">
      <span v-for="(breadcrumb, index) in displayBreadcrumbs" :key="index" class="breadcrumb">
        <RouterLink v-if="breadcrumb.routeName"
                    :to="{ name: breadcrumb.routeName, params: breadcrumb.routeParams || { locale: $i18n.localePath() }}"
                    :title="breadcrumb.routeName" class="link"
        >
          {{ $te(breadcrumb.localeLabel) ? $t(breadcrumb.localeLabel) : breadcrumb.localeLabel }}
        </RouterLink>
        <a v-else-if="breadcrumb.redirectPath" :href="breadcrumb.redirectPath"
           :title="breadcrumb.routeName" class="link"
        >
          {{ $te(breadcrumb.localeLabel) ? $t(breadcrumb.localeLabel) : breadcrumb.localeLabel }}
        </a>
        <span v-else :class="{current: index === (displayBreadcrumbs.length - 1)}" class="text">
          {{ $te(breadcrumb.localeLabel) ? $t(breadcrumb.localeLabel) : breadcrumb.localeLabel }}
        </span>
        <span v-if="index < (displayBreadcrumbs.length - 1)" class="icon material-icons">
          chevron_right
        </span>
      </span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Breadcrumbs',
  components: {},
  directives: {},
  props: {
    breadcrumbs: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {}
  },
  computed: {
    displayBreadcrumbs() {
      return this.breadcrumbs.length > 0
        ? this.breadcrumbs
        : this.$route.meta.breadcrumbs || []
    }
  },
  created() {},
  mounted() {},
  methods: {}
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
.breadcrumbs {
  padding: 24px 0;
  .breadcrumb {
    height: 26px;
    .link,
    .text,
    .icon {
      vertical-align: top;
      margin-right: 8px;
      line-height: 26px;
      font-size: 16px;
      color: $grey-9b;
      text-decoration: none;
    }
    .icon {
      font-size: 20px;
    }
    .text.current {
      color: $grey-7d;
      font-weight: 700;
    }
    .link {
      @include default-link-hover();
    }

  }
}
@media only screen and (min-width: 1440px) {}
@media only screen and (min-width: 1024px) and (max-width: 1439.98px) {
  .breadcrumbs {
    padding: 24px 0;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1023.98px) {
  .breadcrumbs {
    padding: 16px 0;
  }
}
@media only screen and (max-width: 767.98px) {
  .breadcrumbs {
    padding: 16px 0;
  }
}
</style>
